<template>
	<div>
        <a v-if="object" 
            :href="objectOverviewUrl || null" target="_blank" class="gray-100 dinlineb">
            <icon-label 
                :icon="object.icon" 
                :bkgColor="object.class" 
                :value="name" 
                :placeholder="placeholder"
            >
            </icon-label>
        </a>
        <span v-else>
            {{ placeholder }}
        </span>
    </div>
</template>
<script>
    import IconLabel from './IconLabel.vue'
    import { buildUrl, getRouteByName, buildRoute } from '../../helpers'

    export default {
        props : {
            type: {
                type: String,
                required: true,
            },
            id: {
                type: Number,
                required: true
            },
            name : {
                type    : String,
                default : null,
            },
            placeholder: {
                default: '',
                required: false
            },
        },
        data() {
            return {
                list: [
                    {
                        type: 'opportunity',
                        icon: 'icon-opportunity-fillout',
                        class: 'yellow',
                        routeName: 'prospection.opportunity.overview',
                    },
                    {
                        type: 'document',
                        subType: ['estimate', 'invoice', 'creditnote', 'delivery', 'proforma', 'order'],
                        icon: 'icon-document-fillout',
                        class: 'green',
                        routeName: 'invoicing.{type}.overview'.replace('{type}', this.type),
                    },
                    {
                        type: 'purchase',
                        subType: ['purInvoice', 'purCreditNote', 'purDelivery', 'purOrder'],
                        icon: 'icon-document-fillout',
                        class: 'purple',
                        routeName: 'purchase.{type}.overview'.replace('{type}', this.type),
                    },
                    {
                        type: 'expense',
                        icon: 'icon-document-fillout',
                        class: 'grey',
                    }
                ]
            }
        },
        computed: {
            object() {
                return this.list.find((object) => object.type == this.type || (object.subType !== undefined && object.subType.indexOf(this.type) !== -1));
            },
            objectOverviewUrl() {
                return this.urlFromObject(this.object, this.id)
            }
        },
        methods: {
            buildUrl,
            buildRoute,
            getRouteByName,
            urlFromObject(object, id) {
                return this.getRouteByName(
                    this.object.routeName, 
                    [{key: 'id', value: id}]
                )
            }
        },
        components: {
            IconLabel
        },
    }
</script>
